import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import styles from "../styles/fork-overlays.module.css";
/**
 * UI-C: 1px TradingView-style separators between stacked subpanes.
 * Widget-only (reads engine paneSnapshots, draws DOM lines, no engine change).
 */
export function ForkPaneSeparators({ paneSnapshots, lastPaneId, }) {
    if (paneSnapshots.length < 2) {
        return null;
    }
    const resolvedLastId = lastPaneId ?? paneSnapshots[paneSnapshots.length - 1]?.paneId;
    return (_jsx(_Fragment, { children: paneSnapshots.map((snapshot) => {
            if (snapshot.paneId === resolvedLastId) {
                return null;
            }
            const bottom = snapshot.bounds.top + snapshot.bounds.height;
            return (_jsx("div", { "data-pane-separator": snapshot.paneId, className: styles.forkPaneSeparator, style: { top: bottom }, "aria-hidden": "true" }, `pane-separator-${snapshot.paneId}`));
        }) }));
}
